import styled from 'styled-components';

export const MobileDropDownMenuLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: inherit;
`;

export const MobileDropDownMenu = styled.ul`
  margin: 0;
  padding: 0;
`;

export const MobileDropDownMenuItem = styled.li`
  list-style-type: none;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 1.25rem;
  color: ${({ active }) => (active ? '#ffffff' : '#b8b7ad')};
  background-color: ${({ active }) => (active ? '#3d3f4e' : 'transparent')};
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background-color: ${({ active }) => (active ? '#3d3f4e' : '#333540')};
    color: #ffffff;
  }

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
`;

export const LogoutDivider = styled.hr`
  border: none;
  border-top: 1px solid #4a4a5a;
  margin: 0.5rem 1rem;
`;

export const MobileDropDownMenuLastItem = styled.li`
  list-style-type: none;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 1.25rem;
  color: #b8b7ad;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
  border-radius: 4px;

  &:hover {
    background-color: #333540;
    color: #ffffff;
  }
`;

export const HeaderLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: inherit;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: start;
  padding: auto;
  width: 250px;
  margin-top: 20px;
  margin-bottom: 0.5rem;
`;

export const LogoLink = styled.a`

`;

export const Logo = styled.img`
  width: 100%;
`;
